import SimpleTour from './SimpleTour'
import ConnectedSimpleTour from './ConnectedSimpleTour'

export { ConnectedSimpleTour }

export default SimpleTour
